import { createFileRoute } from "@tanstack/react-router";
import AdminPartsStorefront from "@/pages/admin/AdminPartsStorefront";

export const Route = createFileRoute("/_adminLayout/admin/parts/storefront")({
  component: AdminPartsStorefront,
});
